export const isV2PermissionsEnabled = () =>
  String(process.env.REACT_APP_FEATURE_TOGGLE_PERMISSIONS_V2_ENABLED).trim() === 'true';
